import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../../Components/Navbar/navbar";
import styles from "../../Styles/edit.module.css";
import axios from "axios";
import RefreshToken from "../../../Components/RefreshToken/RefreshToken";
import { useLocation, useParams } from "react-router";
import Alert from "../../../Components/Alert/alert";
import { HiOutlineCamera } from "react-icons/hi";
import { Url, getUser } from "../../../Constants/globals";
import Loading from "../../../Components/Loading/loading";
import GoBack from "../../../Components/GoBack/goback";

async function getCompanyDetails(id){
  try {
    const res = await axios
    .get(Url + "/companies/"+id, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getCompanyDetails(id);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function addCompany(nome, nif, setLoading){
  if (nome.trim() === "" || nif.trim() === ""){
    setLoading();
    return ["", <Alert type={"error"}>Todos os campos são obrigatórios</Alert>];
  }
  try {
    const response = await axios
    .post(`${Url}/companies`,
    {
      name: nome,
      nif: nif,
    }, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return [response.data, <Alert type={"success"}>Empresa adicionada com sucesso!</Alert>];
  }
  catch (err) {
    setLoading();
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await addCompany(nome, nif, setLoading);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a empresa");
      return ["", <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a empresa"}</Alert>];
    }
  };
}

async function saveCompany(id, nome, nif, setLoading){
  if (nome.trim() === "" || nif.trim() === ""){
    setLoading();
    return <Alert type={"error"}>Todos os campos são obrigatórios</Alert>;
  }
  try {
    await axios
    .put(`${Url}/companies/${id}`,
    {
      name: nome,
      nif: nif,
    }, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    setLoading();
    return <Alert type={"success"}>Empresa editada com sucesso!</Alert>;
  }
  catch (err) {
    setLoading();
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await saveCompany(id, nome, nif, setLoading);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar a empresa");
      return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar a empresa"}</Alert>;
    }
  };
}

function EditarEmpresas({userPermissions}) {

  const location = useLocation();
  const { state } = location;
  const { id } = useParams();
  const [loading, setLoading] = useState();
  const [loadingData, setLoadingData] = useState(true);
  const [imageHover, setImageHover] = useState(false);
  const [alert, setAlert] = useState("");

  const [nome, setNome] = useState("");
  const [nif, setNif] = useState("");
  const [img, setImg] = useState("");

  const [file, setFile] = useState("");
  const [selectedFile, setSelectedFile] = useState("");

  const fileInputRef = useRef(null);

  const handleImageUpload = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    setFile(event.target.files[0]);
    setSelectedFile(URL.createObjectURL(event.target.files[0]));
  };


  async function assignData() {
    const thisCompanyDetailsData = await getCompanyDetails(id);
    if ( thisCompanyDetailsData.logo_uri){
      setImg(thisCompanyDetailsData.logo_uri);
    }
    setNome(thisCompanyDetailsData.name);
    setNif(thisCompanyDetailsData.nif);
    setLoadingData(false);
  }

  async function getAlertEdit() {
    await setAlert("");
    await setLoading(<Loading/>)
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      try {
        await axios.post(Url+'/companies/'+id+'/image', formData, {
          headers: {
            Authorization: "Bearer " + getUser().token,
            'Content-Type': 'multipart/form-data'
          }
        })
      } catch (err) {
        if (err.request && err.request.status === 401){
          var newToken = await RefreshToken(err);
          if (newToken) {
            return await getAlertEdit();
          }
          else {
            window.location.reload();
          }
        }
        else {
          setLoading();
          console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao alterar o logótipo");
          return setAlert(<Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao alterar o logótipo"}</Alert>);
        }
      }
    }
    const res = await saveCompany(id, nome, nif, setLoading);
    setAlert(res);
  }

  async function addFile(companyId){
    const formData = new FormData();
    formData.append('file', file);
    try {
      await axios.post(Url+'/companies/'+companyId+'/image/', formData, {
        headers: {
          Authorization: "Bearer " + getUser().token,
          'Content-Type': 'multipart/form-data'
        }
      })
    } catch (err) {
      if (err.request && err.request.status === 401){
        var newToken = await RefreshToken(err);
        if (newToken) {
          return await addFile(companyId);
        }
        else {
          window.location.reload();
        }
      }
      else {
        setLoading();
        console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao atribuir o logótipo");
        setAlert(<Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao atribuir o logótipo"}</Alert>);
      }
    }
  }

  async function getAlertAdd() {
    await setLoading(<Loading/>);
    await setAlert("");
    const res = await addCompany(nome, nif, setLoading);
    if (file && res[0].id) {
      await addFile(res[0].id);
    }
    setLoading();
    setAlert(res[1]);
  }
    
  useEffect(() => {
    if (id)
      assignData();
    else {
      setLoadingData(false);
    }
  }, []);

  function handleHoverIn() {
    setImageHover(true);
  }
  function handleHoverOut() {
    setImageHover(false);
  }

  return (
    <div className="body">
      {alert}
      {loading}
      <NavBar current={"empresas"} setDisappear={setLoadingData} userPermissions={userPermissions} />
      {
        loadingData ? ""
        :
        <div className={styles.content}>
          <GoBack backRoute={`/empresas`} backState={state?.page ? {page: state.page} : {}} />
          {
            id ?
            <h1 className={styles.backgroundName}>{nome ? nome : ""}</h1>
            :
            <h1 className={styles.backgroundName}>Adicionar empresa</h1>
          }
          {
            file ?
            <div className={styles.imageDiv} onMouseEnter={() => handleHoverIn()} onMouseLeave={() => handleHoverOut()} onClick={() => setImageHover(true)}>
              <input
                type="file"
                ref={fileInputRef}
                onChange={(e) => handleFileChange(e)}
                style={{display: "none"}}
              />
              <img className={styles.foto} alt="img" src={selectedFile ? selectedFile : ""}/>
              {
                imageHover ?
                <div className={styles.changeImage} onClick={() => handleImageUpload()}>
                  <HiOutlineCamera size={40} color="#fff"/>
                  <p>Alterar logótipo</p>
                </div>
                : ""
              }
            </div>
            :
            img
            ?
            <div className={styles.imageDiv} onMouseEnter={() => handleHoverIn()} onMouseLeave={() => handleHoverOut()} onClick={() => setImageHover(true)}>
              <input
                type="file"
                ref={fileInputRef}
                onChange={(e) => handleFileChange(e)}
                style={{display: "none"}}
              />
              <img className={styles.foto} alt="img" src={`${Url}/image/${img}`}/>
              {
                imageHover ?
                <div className={styles.changeImage} onClick={() => handleImageUpload()}>
                  <HiOutlineCamera size={40} color="#fff"/>
                  <p>Alterar logótipo</p>
                </div>
                : ""
              }
            </div>
            :
            <div className={styles.imageDiv} onMouseEnter={() => handleHoverIn()} onMouseLeave={() => handleHoverOut()} onClick={() => setImageHover(true)}>
              <input
                type="file"
                ref={fileInputRef}
                onChange={(e) => handleFileChange(e)}
                style={{display: "none"}}
              />
              <img className={styles.noFoto} alt="logo"/>
              {
                imageHover ?
                <div className={styles.changeImage} onClick={() => handleImageUpload()}>
                  <HiOutlineCamera size={40} color="#fff"/>
                  <p>Alterar logótipo</p>
                </div>
                : ""
              }
            </div>
          }
          <div className={styles.formBlock}>
            <div className={styles.formBlockSection}>
              <p>Nome:</p>
              <input
                defaultValue={nome}
                onChange={(e) => setNome(e.target.value)}
              />
            </div>
            <div className={styles.formBlockSection}>
              <p>NIF:</p>
              <input
                defaultValue={nif}
                onChange={(e) => setNif(e.target.value)}
              />
            </div>
          </div>
          {
            id ?
            <button className={styles.btn} type="" onClick={() => getAlertEdit()}>Guardar alterações</button>
            :
            <button className={styles.btn} type="" onClick={() => getAlertAdd()}>Adicionar empresa</button>
          }
        </div>
      }
    </div>
  );
}

export default EditarEmpresas;